<div class="popup-container tlms-popup">
	<header>
		<div class="header" style="display:block">{{heading}} Rail Point</div>
		<button class="close" style="top:-3px" (click)="close()">
			<mat-icon>close</mat-icon>
		</button>
	</header>
	<ng-container>
		<div style="padding: 16px 24px 16px 24px;">
			<div class="col-12" style="width: 100%;">
				<div *ngIf="isAdd" class="upload">
					<label class="label">Rail Point Code
						<span style="color:#ff0000">*</span>
					</label>
					<span class="content">
						<input type="text" id="railpointcode" name="railpointcode" required class="railpointcode"
							[(ngModel)]="railPointCode" maxlength="8" minlength="5">
					</span>
				</div>

				<div *ngIf="!isAdd" class="upload">
					<label class="label">Rail Point Code:</label>
					<span class="content">
						{{ railPointCode }}
					</span>
				</div>

				<div class="upload">
					<label class="label">Location
						<span style="color:#ff0000">*</span>
					</label>
					<span class="content">
						<input type="text" id="location" name="location" required class="location"
							[(ngModel)]="location" maxlength="30" size="20">
					</span>
				</div>

				<div class="upload">
					<label class="label">Round Trip Cost
						<span style="color:#ff0000">*</span>
					</label>
					<span class="content">
						<input type="number" min="0" max="99" id="roundtripcost" name="roundtripcost" required
							class="roundtripcost" [(ngModel)]="roundTripCost">
					</span>
				</div>

				<label *ngIf="enableError" class="errormsg">{{errormsg}}</label>
			</div>
		</div>
		<div class="cfooter d-flex justify-content-between align-items-center popup-footer">
			<button (click)="onNoClick()" class="mCancel"> CANCEL
			</button>
			<button class="costpl-submit" style="display: inline" (click)="saveClick()">
				SAVE
			</button>
		</div>
	</ng-container>
</div>